import * as React from 'react'

import { Box, Chevron, Colors, Popover, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import TooltipHeader from 'modules/attendance/components/ClockIn/Tooltip/Header'
import TooltipRow from 'modules/attendance/components/ClockIn/Tooltip/Row'
import MinutesToText from 'modules/attendance/components/MinutesToText'

interface ExtraHoursData {
  extraHoursMinutes: number
  contractHoursMinutes: number
  plannedHoursMinutes: number
  workedHoursMinutes: number
  effectiveWorkedMinutes: number
}

interface ExtraHoursColumnProps {
  extraHoursData: ExtraHoursData
  grayedOutColor: Colors
  extraHoursBaseline: string
}

const ExtraHoursColumn = ({
  extraHoursData,
  grayedOutColor,
  extraHoursBaseline,
}: ExtraHoursColumnProps) => {
  const { extraHoursMinutes, contractHoursMinutes, plannedHoursMinutes, workedHoursMinutes } =
    extraHoursData
  const { effectiveWorkedMinutes } = extraHoursData
  const [open, toggle] = useToggle(false)

  const baselineLabel =
    extraHoursBaseline === 'contract_hours'
      ? i18n.t('clock_in.extra_hours.extra_hours_column.agreement_hours')
      : i18n.t('clock_in.extra_hours.extra_hours_column.planned_hours')

  const baselineValue =
    extraHoursBaseline === 'contract_hours' ? contractHoursMinutes : plannedHoursMinutes

  const workedHoursLabel =
    extraHoursBaseline === 'contract_hours'
      ? i18n.t('clock_in.extra_hours.extra_hours_column.effective_worked_hours')
      : i18n.t('clock_in.extra_hours.extra_hours_column.worked_hours')

  const workedHoursValue =
    extraHoursBaseline === 'contract_hours' ? effectiveWorkedMinutes : workedHoursMinutes

  return (
    <Popover.ItemList attachment="bottom center" toggle={toggle} open={open} gapDivider={false}>
      <Box inline flexDirection="row" gap="s4" alignItems="center">
        <MinutesToText
          value={extraHoursMinutes}
          weight="medium"
          alwaysRemainder
          color={grayedOutColor}
        />
        <Chevron direction={open ? 'up' : 'down'} type="terciary" />
      </Box>
      <Box gap="s12" minWidth="s200">
        <TooltipHeader
          title={i18n.t('clock_in.extra_hours.extra_hours_column.extra_hours')}
          minutes={extraHoursMinutes}
        />

        <TooltipRow label={baselineLabel} value={baselineValue} />

        <TooltipRow label={workedHoursLabel} value={workedHoursValue} />
      </Box>
    </Popover.ItemList>
  )
}

export default ExtraHoursColumn
